import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Button, TextField, Card, CardContent, FormControl, Grid, Input, InputLabel, MenuItem } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PageTitle from '../../../shared/components/PageTitle';
import clsx from 'clsx';
import config from '../../config.json';
import { Formik } from 'formik';
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faAdd } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { addUpdateCustomerRegion, getCompany, getRegion, updateCustomerRegion } from '../../api';


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        margin: theme.spacing(0),
    },
    withoutLabel: {
        marginTop: theme.spacing(0),
    },
    customToastProgress: {
        backgroundColor: '#F59300',
    },
}));

const UserWrapper = styled.div`
    position: relative;
    .css-sghohy-MuiButtonBase-root-MuiButton-root {
        background-color: #F59300 !important;
    }
    .css-1rwt2y5-MuiButtonBase-root-MuiButton-root {
        border : 1px solid #F59300 !important;
        color : #F59300 !important;
    }

    .wrapperWhite {
        background-color: #ffffff;
        padding: 1.5rem;
        border-radius: 18px;
    }

    .MuiTextField-root {
        width: 100%;
    }

    .card-box{
        position: relative;
        overflow: hidden;
        box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
        border-radius: 0.5rem;
        color: rgba(0, 0, 0, 0.87);
        transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
        background-color: #fff;        
        cursor: pointer;
    }
    .card-indicator {
        position: absolute;
        height: 60%;
        top: 20%;
        width: 0px;
        border-top-right-radius: .75rem;
        border-bottom-right-radius: .75rem;
        left: 0;
        transition: all 0.3s linear;
    }
    .badge-primary {
        color: #fff;
        font-weight: 500;    
    }
    .roleName {
        font-size: 14px;
        font-weight: 500;
    }
    .roleItems { 
        width: 100%;
        height: 100%;
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }
    .roleItems:checked ~ .card-indicator {
        width: 6px;
    }
    .customWidth : {
        width : 100% !important
    }
`;


export default function AddEditRegion() {
    const classes = useStyles();
    const [message, setMessage] = React.useState("");
    let loggedinUser = localStorage.getItem("UserName");
    var [clientList, setClientList] = useState([]);
    var [company, setCompany] = useState("");
    var [regionList, setRegionList] = useState([]);
    var [region, setRegion] = useState("");
    var [area, setArea] = useState("");
    var [areaArray, setAreaArray] = useState([]);
    var [areaError, setAreaError] = useState("");
    var [showArea, setShowArea] = useState();
    var [areaListChanged, setAreaListChanged] = useState(false);
    const { id } = useParams();
    const token = config.TOKEN;
    const navigate = useNavigate();
    var [rows, setRows] = useState(
        {
            "name": "",
            "contactName": "",
            "contactPhone": "",
            "clientId": ""
        }
    );
    const deleteAreaMessage = () => toast("Can't delete the Region, because sites are associated with it!");
    const addRegionMsg = () => toast("Region Added Successfully!", { progressClassName: classes.customToastProgress });
    const updateRegionMsg = () => toast("Region Updated Successfully!", { progressClassName: classes.customToastProgress });
    const errorMessage = () => toast("An error occured, try again later!", { progressClassName: classes.customToastProgress });


    useEffect(() => {
        fetchCompany();
        fetchUpdateCustomer();
    }, [])

    const fetchUpdateCustomer = async () => {
        if (id) {
            try {
                const res = await updateCustomerRegion(id);
                if (res.data.successCode === 0) {
                    rows = res.data.data
                    setRows(rows);
                    if (rows.customerId != null) {
                        company = rows?.customerId
                        setCompany(company)
                        fetchRegion(company)
                    }
                    if (rows?.areaList != null) {
                        areaArray = rows?.areaList
                        setAreaArray(areaArray);
                        showArea = true
                        setShowArea(showArea);
                    }
                } else {
                    errorMessage();
                }
            } catch (error) {
                errorMessage();
            }
        }
    }

    const fetchCompany = async () => {
        try {
            const res = await getCompany(loggedinUser);
            if (res.data.successCode === 0) {
                clientList = res.data.data
                setClientList(clientList);
            } else {
                errorMessage();
            }
        } catch (error) {
            errorMessage();
        }
    }

    const fetchRegion = async (company) => {
        try {
            const res = await getRegion(company);
            if (res.data.successCode === 0) {
                regionList = res.data.data
                setRegionList(regionList);
                console.log(regionList);
            } else {
                errorMessage();
            }
        } catch (error) {
            errorMessage();
        }
    }

    const customHandleChange = (e) => {
        company = e.target.value
        setCompany(company);
        fetchRegion(company);
    }

    const addArea = () => {
        if (!area) {
            setAreaError("Enter a area name!");
            setTimeout(() => { setAreaError("") }, 4000);
        } else if (areaArray.find((a) => a.name.toLowerCase() === area.toLowerCase())) {
            setAreaError("Area already exists!");
            setTimeout(() => { setAreaError("") }, 4000);
        } else {
            areaArray.push({ "name": area })
            setAreaArray(areaArray);
            setArea("");
            setShowArea(true);
            setAreaListChanged(true);
        }
    }

    const deleteArea = (i, e) => {
        if (e.siteCount > 0) {
            deleteAreaMessage()
        } else {
            setAreaArray((areaArray) => {
                return areaArray.filter((arrElem, index) => {
                    return index !== i;
                });
            });
        }
        setAreaListChanged(true);
    }

    const displayArea = () => {
        if (showArea)
            return (
                <Grid item xs={12} sm={8} md={8} className="pt-3">
                    <Grid container spacing={4} className='pt-4'>
                        {areaArray.map((e, index) => {
                            console.log(areaArray);
                            return (
                                <Grid item xs={12} sm={6} md={6} key={e} >
                                    <Card style={{ backgroundColor: "#F0F0F0" }} >
                                        <CardContent className="d-flex justify-content-between pb-0">
                                            <div>
                                                {id && e.id ? <p style={{ wordBreak: "break-word", cursor: "pointer" }} onClick={() => navigate("/customer/list?clientId=" + rows.id + "&regionId=" + e.id)}>{e.name}</p>
                                                    : <p>{e.name}</p>}
                                            </div>
                                            <div>
                                                <FontAwesomeIcon icon={faClose} className="closeIcon" onClick={() => deleteArea(index, e)} />
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )
                        })}
                    </Grid>
                </Grid>
            )
    }

    return (
        <Formik
            enableReinitialize={true}
            initialValues={{
                // Name: rows?.name
                //  Client: rows?.clientId, ContactName: rows?.contactName, ContactPhone: rows?.contactPhone
                clientId: company || "",
                Region: rows?.id || ""
            }}
            validate={values => {
                const errors = {};
                // if (!values.Client) {
                //     errors.Client = 'Required!';
                // }
                // if (!values.Name) {
                //     errors.Name = 'Required!';
                // }
                if (!company) {
                    errors.clientId = 'Required!';
                }
                if (!values.Region) {
                    errors.Region = 'Required!';
                }
                return errors;
            }}

            const handleMouseDownPwd={(event) => {
                event.preventDefault();
            }}
            onSubmit={async (values, { setSubmitting }) => {
                const postData = {
                    id: id ? id : values.Region,
                    name: regionList.find((option) => option.id === values.Region)?.name || "",
                    customerId: company,
                    areaList: areaArray,
                    // regionId: values.region,
                    areaListUpdated: areaListChanged
                    // name: values.Name,
                    // contactName: values.ContactName,
                    // contactPhone: values.ContactPhone,
                    // userName: loggedinUser
                }
                console.log(postData);
                try {
                    const res = await addUpdateCustomerRegion(postData);
                    if (res.data.successCode === 0) {
                        { id ? updateRegionMsg() : addRegionMsg() }
                    } else {
                        errorMessage();
                    }
                    setTimeout(() => {
                        navigate("/region/list")
                    }, 2000);
                } catch (error) {
                    errorMessage();
                    setTimeout(() => {
                        navigate("/region/list")
                    }, 2000);
                }
                setSubmitting(false)
            }}

        >

            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,

            }) => (
                <form onSubmit={handleSubmit}>
                    <UserWrapper>
                        <ToastContainer theme="dark" />
                        <Grid container spacing={4} className='d-flex justify-content-center'>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <PageTitle>Region</PageTitle>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">

                            </Grid>

                            {/* <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField
                                    style={{ width: "99%" }}
                                    className="filterDropdown"
                                    id="status"
                                    select
                                    label="Select Company"
                                    helperText=""
                                    variant="standard"
                                    name="companyId"
                                    onChange={(e) => customHandleChange(e)}
                                    onBlur={handleBlur}
                                >
                                    {clientList.map((option) => (
                                        <MenuItem key={option.id} option={option.id}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid> */}
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField
                                    // fullWidth
                                    style={{ width: "99%" }}
                                    disabled={!!id}
                                    className="filterDropdown"
                                    id="status"
                                    select
                                    label="Select Company"
                                    helperText=""
                                    variant="standard"
                                    name="clientId"
                                    value={company || ''}
                                    onBlur={handleBlur}
                                    onChange={(e) => customHandleChange(e)}>
                                    {clientList.map(option => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <span className="errMsg">{errors.clientId && touched.clientId && errors.clientId}</span>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField
                                    style={{ width: "99%" }}
                                    disabled={!!id}
                                    className="filterDropdown"
                                    id="status"
                                    select
                                    label="Select Region"
                                    helperText=""
                                    variant="standard"
                                    name='Region'
                                    value={values.Region || ""}
                                    // onChange={(e) => setRegion(e.target.value)}
                                    onChange={handleChange}
                                    onBlur={handleBlur}>
                                    {regionList.map((option) => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <span className="errMsg">{errors.region && touched.region && errors.region}</span>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8}>
                                <TextField
                                    style={{ width: "85%" }}
                                    className="filterDropdown"
                                    id="area"
                                    label="Area"
                                    helperText=""
                                    variant="standard"
                                    name="area"
                                    type="text"
                                    value={area}
                                    onBlur={handleBlur}
                                    onChange={e => setArea(e.target.value)}
                                />
                                <span className="errMsg">{areaError}</span>
                                <FontAwesomeIcon icon={faAdd} className="closeIcon m-3"
                                    style={{
                                        borderRadius: "50%",
                                        backgroundColor: "rgb(245, 147, 0)",
                                        color: "white",
                                        padding: "5px",
                                        fontSize: "20px",
                                        cursor: "pointer"
                                    }} onClick={() => addArea()} />
                            </Grid>
                            {displayArea()}
                            <Grid item xs={12} sm={8} md={8} className="text-right mt-4">
                                <Button type="button" variant="outlined" color="primary" className="noShadow cancelBtn" onClick={() => navigate("/region/list")}>
                                    Cancel
                                </Button>&nbsp;&nbsp;
                                <Button type="submit" variant="contained" color="primary" className="noShadow addBtn" disabled={isSubmitting} >
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </UserWrapper>
                </form>
            )
            }
        </Formik>
    );
}
